import React from 'react'
import "./app.css"

const Home = (props) => {
    return(
        <div class="img">
            <img src="/invoice.png" alt="home"/>
        </div>
    )
}
export default Home
